import React from 'react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Organicé toda la documentación del consultorio en un fin de semana. Ahora mi asistente sabe exactamente qué hacer sin preguntarme nada. Nunca más improviso la recepción.',
    author: 'Mariana L.',
    role: 'Odontóloga · Buenos Aires'
  }, {
    quote: 'Los consentimientos informados cambiaron todo. Logré tener respaldo legal en todos mis procedimientos después de un año sin nada firmado. Y sin contratar a nadie.',
    author: 'Rodrigo P.',
    role: 'Odontólogo · Rosario'
  }, {
    quote: 'Adapto el protocolo de cada sesión en 5 minutos. Antes me llevaba media hora pensar qué documentar y cómo. Ahora el consultorio funciona igual si estoy o si falto.',
    author: 'Florencia M.',
    role: 'Odontóloga · Córdoba'
  }];
  return <section className="bg-offWhite px-5 py-10 md:py-[60px]" data-id="element-232">
      <div className="mx-auto max-w-[1000px]" data-id="element-233">
        <p className="mb-3 text-center font-montserrat text-[11px] font-extrabold uppercase tracking-[3px] text-brandRed" data-id="element-234">
          Lo que dicen los que ya lo tienen
        </p>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-235">
          {testimonials.map((t, i) => <div key={i} className="rounded-[10px] border-l-4 border-brandRed bg-white p-7 shadow-[0_2px_16px_rgba(0,0,0,0.06)]" data-id="element-236">
              <blockquote className="mb-[18px] text-[15px] italic leading-relaxed text-[#333]" data-id="element-237">
                "{t.quote}"
              </blockquote>
              <cite className="block font-montserrat text-[12px] font-bold not-italic text-navy" data-id="element-238">
                {t.author}{' '}
                <span className="font-normal text-brandGray" data-id="element-239">— {t.role}</span>
              </cite>
            </div>)}
        </div>
      </div>
    </section>;
}